<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title flex-end">List Of Qr Codes</div>
      <!-- <div>
        <router-link class="btn-blue" :to="'/qr-code/add-qr-code'">{{
          $t("ADD")
        }}</router-link>
      </div> -->
    </div>
    <div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>QR Code</th>
                  <th>Code Url</th>
                  <th>Movies Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody v-if="qrData.length > 0">
                <tr v-for="(item, index) in qrData" :key="index">
                  <td>{{ item.QRcodeID }}</td>
                  <td>
                    <div class="image-placeholder">
                      <img
                        :src="`${item.qrcodepath}`"
                        width="200"
                        height="200"
                      />
                    </div>
                  </td>
                  <td>
                    <a :href="item.qr_code_url" target="__blank">
                      {{ item.qr_code_url || "-" }}
                    </a>
                  </td>
                  <td>{{ item.movie_title || "-" }}</td>

                  <td class="text-right">
                    <b-dropdown right variant="edit" class="ml-4">
                      <b-dropdown-item
                        @click="goToRoute('/qr-code/edit-qr-code', item)"
                      >
                        <span class="edit-pen"></span>
                        {{ $t("edit") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="qrData.length == 0">
                <tr>
                  <td colspan="3">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QrService from "@/services/QrService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  name: "qrpage",
  components: {
    StatusDot,
    NoRecords
  },
  data() {
    return {
      qrData: []
    };
  },
  beforeMount() {
    this.getQrCodes();
  },
  methods: {
    goToRoute: function(path, item) {
      //console.log("item :", item);
      const { QRcodeID } = item;
      this.$router.push({
        path: path,
        query: {
          qr_id: QRcodeID
        }
      });
    },
    getQrCodes() {
      QrService.GetListOfQrCodes()
        .then(response => {
          const { data } = response;
          console.log(data);
          if (data.Records.length > 0) {
            this.qrData = data.Records;
          } else {
            this.qrData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/viewListOfQrCodes.vue